// Autogenerated by `pnpm version-file`. DO NOT EDIT
export var VERSION = '1.27.5';
//# sourceMappingURL=version.js.map